const userKeys = {
  all: ["user"] as const,
  stakes: () => [...userKeys.all, "stakes"] as const,
  vaultPosition: () => [...userKeys.all, "vault-position"] as const,
}

const mezoKeys = {
  all: ["mezo"] as const,
  stakingStats: () => [...mezoKeys.all, "staking-stats"] as const,
  vaultStats: () => [...mezoKeys.all, "vault-stats"] as const,
}

export default {
  userKeys,
  mezoKeys,
}
